import { useMemo } from 'react';
import { Theme } from '@mui/material/styles';

import { useAppSelector } from 'store/hooks';
import { PortalConfigSelector } from 'store/config/selectors';
import { createThemeFromConfig } from 'utils/theme';
import { ThemeModeSelector } from '../store/themeMode';
import { UIModeSelector } from '../store/uiMode';
import { createThemeFromConfigOld } from '../utils/themeOld';

export const useTheme = (): Theme => {
  const { colorScheme } = useAppSelector(PortalConfigSelector);
  const themeMode = useAppSelector(ThemeModeSelector);
  const isNewUI = useAppSelector(UIModeSelector);
  if (!isNewUI) {
    return useMemo(
      () =>
        createThemeFromConfigOld(colorScheme && colorScheme !== '' ? colorScheme : '#000', 'white', themeMode),
      [colorScheme, themeMode, isNewUI],
    )
  }
  return useMemo(
    () =>
      createThemeFromConfig(
        colorScheme && colorScheme !== '' ? colorScheme : '#000',
        'white',
        themeMode,
      ),
    [colorScheme, themeMode, isNewUI],
  );
};
